import { 
    getAsusDeviceList,
    getAsusAlldataBydeviceId,
    getAsusSleepdataBydeviceId,
    addNewAsusDevice,
    modifyAsusDevice
} from '@/api/asusdeviceService';
import store from '@/store';
import lodash from "lodash";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { DEVICEMEASUREMENTTYPE } from '@/utils/store-util'
import { asusDownloadoptions, deviceIdsType, deviceNew, deviceEdit} from '@/types/asusdevice';


export interface AsusDeviceState {
    loading: boolean;
    totaldevices: number;
    devicelist: deviceIdsType[];
}

@Module({ store, dynamic: true, name: 'asusDeviceModule' })
class AsusDeviceModule extends VuexModule implements AsusDeviceState {
    public loading = false;
    public devicelist:deviceIdsType[] = [];
    public downloaddata = [];
    public downloadsleep = [];
    public totaldevices = 0;

    @Action async addNewDevice(addnewItem:deviceNew) {
        this.setLoading(true);
        await addNewAsusDevice(addnewItem.device_id, addnewItem.device_name);
        this.setLoading(false);
        this.getDeviceList();
    }
    @Action async modifyDevice(editItem:deviceEdit) {
        this.setLoading(true);
        await modifyAsusDevice(editItem.device_id, editItem.device_name, editItem.start_time, editItem.end_time, editItem.iid);
        this.setLoading(false);
        this.getDeviceList();
      }

    @Action({ rawError: true }) async getDeviceList(): Promise<TODO> {
        this.setLoading(true);
        const data = await getAsusDeviceList();
        this.setDeviceList(data.device);
        this.setTotalDevices(data.device.length);
        this.setLoading(false);
    }

    @Action async getDownloaddata(payload:asusDownloadoptions){
        this.setLoading(true);
        this.clearDownloaddata();
        const data = [];
        for (const device of payload.device_ids){
            const response = await getAsusAlldataBydeviceId(device['device_id'], payload.start, payload.end);
            const device_data = response.records;
            const total_records = response.total_records;
            const user_temp = {};
            if(total_records !== 0){
                await device_data.forEach((element) => {
                    element.measure_at = new Date(
                        element.measure_at * 1000
                    ).toLocaleString('zh-TW',{
                        day: '2-digit',    //(e.g., 01)
                        month: '2-digit',    //(e.g., 06)
                        year: 'numeric',   //(e.g., 2021)
                        hour: '2-digit',   //(e.g., 02)
                        minute: '2-digit', //(e.g., 02)
                        second: '2-digit', //(e.g., 05)
                    });
                    if(element.measure_at === user_temp['日期']){
                        Object.entries(DEVICEMEASUREMENTTYPE[element.category]['children']).forEach(([key, value])=>{
                            user_temp[value['name']+`(單位:${value['name']})`] = element[key];
                        })
                    }else{
                        if(!lodash.isEmpty(user_temp)) data.push(lodash.cloneDeep(user_temp));
                        Object.keys(user_temp).forEach(k => delete user_temp[k]);
                        user_temp['手錶編號'] = device['device_id'];
                        user_temp['日期'] = element.measure_at;
                        Object.entries(DEVICEMEASUREMENTTYPE).forEach(([key, value]) => {
                            if(key!=="sleep"){
                                if(key===element.category){
                                    Object.entries(value.children).forEach(([childkey, childvalue]) =>{
                                        user_temp[childvalue.name+`(單位:${childvalue.unit})`] = element[childkey];
                                    });
                                }else{
                                    Object.entries(value.children).forEach(([childkey, childvalue]) =>{
                                        user_temp[childvalue.name+`(單位:${childvalue.unit})`] = null;
                                    });
                                }
                            }
                        });
                    }
                });
                if(!lodash.isEmpty(user_temp)) data.push(lodash.cloneDeep(user_temp));
            }
        }
        this.setDownloaddata(data);
        this.setLoading(false);
    }

    // @Action async getDownloadsleep(device_ids:[], start, end){
    // TODO
    // }

    @Action clearDownloaddata(){
        this.setDownloaddata([]);
    }

    @Action clearDownloadsleep(){
        this.setDownloadsleep([]);
    }
    
    @Mutation setDownloaddata(downloaddata):void {
        this.downloaddata = lodash.cloneDeep(downloaddata);
    }

    @Mutation setDownloadsleep(downloadsleep):void {
        this.downloadsleep = lodash.cloneDeep(downloadsleep);
    }

    @Mutation setDeviceList(devicelist: []): void {
        this.devicelist = lodash.cloneDeep(devicelist);
    }

    @Mutation setLoading(loading: boolean):void {
        this.loading = loading;
    }

    @Mutation setTotalDevices(total: number):void {
        this.totaldevices = total;
    }
}

export const asusDeviceModule = getModule(AsusDeviceModule);